import { type Tariff, TariffStatus } from 'Services/ProductManagement/Features/Tariff/tariffSlice'
import { ENABLE_TARIFF_EDIT_RESTRICTION } from 'Util/constants'

/**
 * Checks if the tariff is in an editable status
 */
export const isTariffEditAllowed = (tariff: Tariff | null): boolean => {
  if (!tariff) return false

  // Restrictions apply only in production
  if (!ENABLE_TARIFF_EDIT_RESTRICTION) {
    return true
  }

  const editableStatuses = [TariffStatus.DRAFT, TariffStatus.STAGED]
  return editableStatuses.includes(tariff.status)
}
